export default __webpack_public_path__ + "static/media/480px-120px-Scrub-Sky-Turbines-Hero-Large.71317c12.jpg";